/** Time-bucket granularity for the job completion rate graph. Keep in sync with JobCompletionGranularity in Omnius.Custom.Common\Enumerations\Jobs. */
enum JobCompletionGranularity {
  FifteenMinute = "FifteenMinute",
  Hour = "Hour",
}

interface JobCompletionGranularityOption {
  label: string;
  value: JobCompletionGranularity;
}

const GRANULARITY_OPTIONS: JobCompletionGranularityOption[] = [
  { label: "Hour", value: JobCompletionGranularity.Hour },
  { label: "15 Minute", value: JobCompletionGranularity.FifteenMinute },
];

/** One x-axis bucket of the graph, with the success/failure counts and their trend values. */
interface JobCompletionPoint {
  bucketStart: string;
  failureCount: number;
  failureTrend: number | null;
  successCount: number;
  successTrend: number | null;
}

export { GRANULARITY_OPTIONS, JobCompletionGranularity, JobCompletionGranularityOption, JobCompletionPoint };
